import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { ProductDocument } from 'tolaria-cloud-functions/src/_interfaces/marketplace.interface';
import { UserService } from '../../_shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ProductListingService {

  private _products$ = new BehaviorSubject<ProductDocument[] | null>(null)
  public products$ = new BehaviorSubject<ProductDocument[] | null>(null)
  public ready$ = new BehaviorSubject<boolean>(false)
  

  constructor(
    private readonly firestore: AngularFirestore,
    private readonly user: UserService,
  ) {
    this.init()
  }

  private init(): void {
    this.firestore
      .collection('marketplace')
      .doc('store')
      .collection<ProductDocument>('products')
      .valueChanges()
      .subscribe((products: ProductDocument[]) => {
        console.log('ProductListingService:: products emitted new value ->', products)
        products.forEach(product => {
          let mainImage = [
            ...product.images.filter(img => img.isMain),
            ...product.variants.map(variant => variant.images.filter(i => i.isMain)).flat(),
          ]
          let images = [
            ...product.images,
            ...product.variants.map(variant => variant.images).flat(),
          ]
          product.mainImageUrl = mainImage[0]
            ? mainImage[0].imageUrl
            : images[0]
              ? images[0].imageUrl
              : null
          product.mainImageThumb = mainImage[0]
          ? mainImage[0].thumbnail
          : images[0]
            ? images[0].thumbnail
            : null
          if (product.hasVariants) {
            product.stockOnVariants = product.variants.reduce((acc, variant) => acc + variant.stock, 0)
          }
          else {
            product.stockOnVariants = 0
          }
        })
        this._products$.next(products)
        this.products$.next(products.filter(i => i.status !== 'inactive'))
        if (this.ready$ && !this.ready$.getValue()) this.ready$.next(true)
      })
  }

  public getProduct(slug: string): ProductDocument | null {
    const products = this.products$.getValue()
    return products ? products.find(p => p.slug === slug) || null : null
  }

  getProductById(id: string): ProductDocument | undefined {
    const products = this.products$.getValue()
    return products.find(p => p.id === id)
  }

  getUsersProducts(): Observable<ProductDocument[]> {
    
    return this._products$.pipe(
      filter(products => products !== null), // filter out initial null
      map(products => (products ?? []).filter(p => p.createdByUid === this.user.getUid()))
    )
  }
  


}
